import { SendEmailSchema } from "@billingnow/zod-schema";
import { apiClient } from "./client";

export const sendDocumentEmail = async (emailData: SendEmailSchema): Promise<string> => {
  const response = await apiClient.post<string>("/api/email/send", emailData, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};
